import { render } from "./Fishing.vue?vue&type=template&id=0fdc1d34&scoped=true"
import script from "./Fishing.vue?vue&type=script&lang=js"
export * from "./Fishing.vue?vue&type=script&lang=js"

import "./Fishing.vue?vue&type=style&index=0&id=0fdc1d34&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0fdc1d34"

export default script